import React from 'react';
import css from './ShowAll.css';

const ShowAll = () => <div className={css['show-all']}>Show all results</div>;

export default ShowAll;
